import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Typography } from '@wbk/ui';
import { useOnClickOutside } from '@/hooks/use-on-click-outside';

type OtherSupportModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (value: string) => void;
};

const OtherSupportModal = ({ isOpen, onClose, onAdd }: OtherSupportModalProps) => {
  const { t } = useTranslation('common');
  const [inputValue, setInputValue] = React.useState('');
  const modalRef = React.useRef<HTMLDivElement>(null);

  useOnClickOutside(modalRef as React.RefObject<HTMLElement>, () => {
    onClose();
    setInputValue('');
  });

  if (!isOpen) return null;

  const handleAdd = () => {
    if (inputValue.trim()) {
      onAdd(inputValue);
      setInputValue('');
      onClose();
    }
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm'>
      <div
        ref={modalRef}
        className='w-full max-w-md rounded-2xl border border-white/10 bg-[#1E1E1E] p-8 shadow-2xl'
      >
        <div className='space-y-6'>
          <Typography as='h3' variant='body-M' className='text-center font-bold text-white'>
            {t('sponsor_form.other_support_modal.title')}
          </Typography>

          <Input
            value={inputValue}
            onChange={(val) => setInputValue(val)}
            placeholder={t('sponsor_form.other_support_modal.placeholder')}
            className='rounded-sm border border-white/20 bg-white/20 text-base hover:bg-white/20 focus-visible:bg-white/20'
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAdd();
              }
            }}
          />

          <div className='flex gap-4'>
            <Button
              theme='transparent'
              className='flex-1 text-sm'
              onClick={() => {
                setInputValue('');
                onClose();
              }}
            >
              {t('sponsor_form.other_support_modal.cancel')}
            </Button>
            <Button className='flex-1 rounded-full py-2 text-sm' onClick={handleAdd}>
              {t('sponsor_form.other_support_modal.add')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherSupportModal;
